import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { authenticatedRoute } from "../_authenticated.js";

export const companiesRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/companies",
  component: lazyRouteComponent(() => import("./companies.page.js"), "CompaniesPage"),
});
